import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { herlaadVoorNieuweVersie } from "./lib/nieuweVersie";
import "./styles.css";

// Vite meldt zelf als een los stuk van een oudere versie niet meer te laden is.
window.addEventListener("vite:preloadError", (e) => {
  if (herlaadVoorNieuweVersie()) e.preventDefault();
});

// De openbare leeslink van een plan (/lees/<token>): buiten de inlog, zonder
// menu en zonder /api/mij (ADR 2026-11-04-plan-instellen-delen-bouwplan). De
// pagina laadt pas als iemand een link opent; een kapotte link krijgt daar zijn
// eigen melding in plaats van het inlogscherm.
const LEES_PAD = /^\/lees\/([^/]*)\/?$/;
const leesToken = LEES_PAD.exec(window.location.pathname)?.[1] ?? null;
const LeesPlan = lazy(() => import("./pages/LeesPlan"));

const root = document.getElementById("root");
if (!root) throw new Error("#root ontbreekt in index.html");

createRoot(root).render(
  <StrictMode>
    {leesToken ? (
      <Suspense fallback={null}>
        <LeesPlan token={leesToken} />
      </Suspense>
    ) : (
      <App />
    )}
  </StrictMode>,
);
